import { render, staticRenderFns } from "./CadastroModeloDocumentacaoAcessoria.vue?vue&type=template&id=ea72813e&scoped=true"
import script from "./CadastroModeloDocumentacaoAcessoria.vue?vue&type=script&lang=js"
export * from "./CadastroModeloDocumentacaoAcessoria.vue?vue&type=script&lang=js"
import style0 from "./CadastroModeloDocumentacaoAcessoria.vue?vue&type=style&index=0&id=ea72813e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72813e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VRow,VTextField,VTextarea})
